import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { PaginationState } from '@tanstack/react-table';

import { DEFAULT_PAGE_SIZE } from '../constants';

function clampPageIndex(pagination: PaginationState) {
  return {
    ...pagination,
    pageIndex: Math.max(0, pagination.pageIndex),
  };
}

export function useServerPagination(initialPageSize: number | undefined) {
  const [{ pageIndex, pageSize }, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: initialPageSize ?? DEFAULT_PAGE_SIZE,
  });

  // Workaround for https://github.com/TanStack/table/issues/4271
  // Until https://github.com/TanStack/table/pull/4370 is merged to fix it
  const handleSetPagination: Dispatch<SetStateAction<PaginationState>> = useCallback(
    (paginationOrUpdater: PaginationState | ((prevState: PaginationState) => PaginationState)) => {
      if (typeof paginationOrUpdater === 'function') {
        setPagination((prevState) => clampPageIndex(paginationOrUpdater(prevState)));
      } else {
        setPagination(clampPageIndex(paginationOrUpdater));
      }
    },
    []
  );

  return { pageIndex, pageSize, setPagination: handleSetPagination };
}
